import { useTranslation } from 'react-i18next'
import { useTeam } from '@/hooks/useTeam'
import type { TeamMember } from '@/services/cms'

function TeamRow({ members }: { members: TeamMember[] }) {
  return (
    <div className="flex flex-wrap gap-4">
      {members.map(member => (
        <div key={member.id} className="flex flex-col text-center">
          <img
            src={member.image}
            alt=""
            width={119}
            height={127}
            className="bg-muted mb-2 h-[127px] w-[119px] rounded-xl object-cover"
          />
          <span className="text-foreground mb-0.5 text-[10px] font-semibold">{member.name}</span>
          <span className="text-discover-team-profession max-w-[112px] text-[10px] font-normal">
            {member.role}
          </span>
        </div>
      ))}
    </div>
  )
}

export function TeamContent() {
  const { t } = useTranslation()
  const { categoriesWithMembers, isLoading, isError } = useTeam()

  if (isLoading) {
    return (
      <div className="bg-card px-6 py-4">
        <p className="text-foreground text-center text-sm">
          {t('discover.sections.teamSection.loading')}
        </p>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="bg-card px-6 py-4">
        <p className="text-destructive text-center text-sm">
          {t('discover.sections.teamSection.error')}
        </p>
      </div>
    )
  }

  if (categoriesWithMembers.length === 0) {
    return (
      <div className="bg-card px-6 py-4">
        <p className="text-foreground text-center text-sm">
          {t('discover.sections.teamSection.empty')}
        </p>
      </div>
    )
  }

  return (
    <div className="bg-card px-6 py-4">
      {categoriesWithMembers.map(({ category, members }, index) => (
        <div key={category.id} className={index === 0 ? '' : 'mt-10'}>
          <h2 className="text-foreground mb-6 text-2xl font-semibold">{category.name}</h2>
          <TeamRow members={members} />
        </div>
      ))}
    </div>
  )
}
